import type { MagazineIssue } from './rothusMagazines';

/** Die API ist die Veröffentlichungsquelle; Datumsreihenfolge bleibt auch bei unsortierten Antworten stabil. */
export const selectCurrentRothusIssue = (issues: MagazineIssue[]): MagazineIssue | null =>
  [...issues]
    .filter(issue => issue.current_issue_eligible === true)
    .sort((a, b) => Date.parse(b.publication_date) - Date.parse(a.publication_date) ||
      Number(b.issue_number) - Number(a.issue_number))[0] ?? null;

export const currentIssueCopy = (issue: MagazineIssue, language: 'de' | 'en') => ({
  title: issue.editorial_title || (language === 'en' ? `glide Issue ${issue.issue_number}` : `glide Ausgabe ${issue.issue_number}`),
  teaser: issue.editorial_teaser || (language === 'en'
    ? 'Discover the latest issue of glide — the Swiss cross-country skiing magazine.'
    : 'Entdecke die aktuelle Ausgabe von glide — dem Schweizer Langlauf-Magazin.'),
  highlights: issue.editorial_highlights ?? [],
});